module.exports = __webpack_public_path__ + "static/media/0121_IMG_LE_SOL_WOOD_SPIRIT_TEINTE_SPECIALE.06802159.webp";